import { useContext, type FunctionComponent } from 'react';
import { getConditionalQuestion } from '../../../domain/question';
import { SurveyPageContext } from '../../context/SurveyPageContext';
import Question from '../Question/Question';

interface ConditionalQuestionProps {
  conditionalQuestionId: number;
}

const ConditionalQuestion: FunctionComponent<ConditionalQuestionProps> = ({
  conditionalQuestionId,
}) => {
  const { survey } = useContext(SurveyPageContext);
  const question = survey && getConditionalQuestion(conditionalQuestionId, survey);

  return question ? <Question question={question} /> : <></>;
};

export default ConditionalQuestion;
